import React, {useState} from 'react'
import {Nav,NavItem,Dropdown,DropdownItem,DropdownToggle,DropdownMenu,NavLink,Container,Col, Row} from 'reactstrap';

function MainePOS() {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(!dropdownOpen);
  return (
    <>
    <Container>
    <Row>
        <Col xs='4' sm='4' md='4' style={{border:'3px'}}>
            <Container></Container>
        </Col>
        <Col xs='auto' sm='auto' md='auto' >
        
        <Nav tabs>
            <NavItem>
                <NavLink href="#" active>
                Link
                </NavLink>
            </NavItem>
            <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle nav caret>
                Dropdown
                </DropdownToggle>
                <DropdownMenu>
                <DropdownItem header>Header</DropdownItem>
                <DropdownItem disabled>Action</DropdownItem>
                <DropdownItem>Another Action</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Another Action</DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <NavItem>
                <NavLink href="#">Link</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href="#">Another Link</NavLink>
            </NavItem>
            <NavItem>
                <NavLink disabled href="#">
                Disabled Link
                </NavLink>
            </NavItem>
        </Nav>
        </Col>
    </Row>
    </Container>
    </>
  )
}

export default MainePOS